// applyMiddleware는 미들웨어들을 합쳐주는 역할.
// createStore 앱의 상태 트리 전체를 보관하는 Redux 스토어를 만듭니다.
import { applyMiddleware, createStore } from 'redux';
// 비동기 처리 모듈
import thunk from 'redux-thunk';
import reducers from 'reducers';
import promiseMiddleware from 'redux-promise-middleware';

const middlewares = [thunk, promiseMiddleware()];

const loggers = createStore(reducers, applyMiddleware(...middlewares));

export const gaId = {
  DMP_TRACKING_ID: process.env.NODE_ENV === 'development' ? 'G-LHFHDCBNBL' : 'G-DF0YJ3L6MJ',
  MARKETING_TRACKING_ID: process.env.NODE_ENV === 'development' ? 'G-4XJBN0EEXJ' : 'G-Z7GML2Y6G3'
};

export default loggers;
